import Link from 'next/link'
import React from 'react'

export const SiteFooter = () => (
  <footer className="px-6 py-16 space-y-3">
    <div className="max-w-6xl mx-auto text-center flex flex-col items-center space-y-5">
      <ul className="flex space-x-6 text-white text-opacity-80 hover:text-opacity-100 text-sm transition duration-300">
        <li>
          <Link href="https://reflect.app/discord">
            <a>Discord</a>
          </Link>
        </li>

        <li>
          <Link href="https://twitter.com/reflectnotes">
            <a>Twitter</a>
          </Link>
        </li>

        <li>
          <Link href="/terms">
            <a>Terms</a>
          </Link>
        </li>

        <li>
          <Link href="/privacy">
            <a>Privacy</a>
          </Link>
        </li>
      </ul>

      {/* Copyrights note */}
      <div className="text-sm text-[#B1B2DD]">Reflect App, LLC. All rights reserved.</div>
    </div>
  </footer>
)
